"use client";
import { CalendarCheck2, Copy, LogIn, SparklesIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import useAuthModal from "@/features/auth/hooks/use-auth-modal";
import { useI18n } from "@/locales/client";

export const SignUpCard = () => {
  const { onOpen } = useAuthModal();
  const t = useI18n();

  const signUpCardArr = [
    {
      title: t("signUpCard.features.unlimitedQuestions.title"),
      description: t("signUpCard.features.unlimitedQuestions.description"),
      icon: Copy,
    },
    {
      title: t("signUpCard.features.aiCreation.title"),
      description: t("signUpCard.features.aiCreation.description"),
      icon: SparklesIcon,
    },
    {
      title: t("signUpCard.features.tracking.title"),
      description: t("signUpCard.features.tracking.description"),
      icon: CalendarCheck2,
    },
  ];

  return (
    <Card className="bg-[#0077FF0D] rounded-2xl">
      <CardHeader className="flex flex-row items-center justify-between">
        <div className="space-y-1.5">
          <CardTitle className="text-lg font-semibold leading-5">
            {t("signUpCard.title")}
          </CardTitle>
          <CardDescription className="text-xs leading-4 font-normal">
            {t("signUpCard.description")}
          </CardDescription>
        </div>

        <Button
          onClick={() => onOpen()}
          className="text-sm font-noraml flex gap-2 hover:text-brand-primary text-brand-primary h-6"
          variant={"ghost"}
          size={"sm"}
        >
          <LogIn className="size-4" />
          {t("signUpCard.signUp")}
        </Button>
      </CardHeader>
      <CardContent className="hidden md:flex flex-col gap-4">
        {signUpCardArr.map((item) => (
          <div key={item.title} className="flex items-start gap-2">
            <item.icon className="size-4 text-[#0077FF] mt-1" />

            <div className="space-y-1.5">
              <h6 className="font-medium text-sm leading-3">{item.title}</h6>
              <p className="text-xs font-normal text-muted-foreground">
                {item.description}
              </p>
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};
